<ng-container *ngIf="cardType === 'data'">
  <mat-card class="data-card" (click)="emitCardClicked($event)" [id]="id" onkeypress="emitCardClicked($event)">
    <h2>{{ title }}</h2>
    <img mat-card-image [src]="imgSrc" [alt]="imgAlt" />
    <mat-card-content>
      <h2>{{ content }}</h2>
    </mat-card-content>
  </mat-card>
</ng-container>
<ng-container *ngIf="cardType === 'display'">
  <mat-card class="display-card mat-elevation-z6">
    <ng-content></ng-content>
  </mat-card>
</ng-container>
<ng-container *ngIf="cardType === 'image-display'">
  <mat-card class="image-display-card mat-elevation-z6">
    <img *ngIf="imgSrc" mat-card-image [src]="imgSrc" [alt]="imgAlt" />
  </mat-card>
</ng-container>
<ng-container *ngIf="cardType === 'video-display'">
  <mat-card class="video-display-card mat-elevation-z6">
    <video *ngIf="videoSrc" width="100%" controls>
      <source [src]="videoSrc" [type]="videoType" />
    </video>
  </mat-card>
</ng-container>
